import axios from 'axios';
import store from '@/store';

export const authClient = axios.create({
  baseURL: process.env.VUE_APP_APIURL,
  withCredentials: true, // required to handle the CSRF token
});

/* `
 * Add a response interceptor
 */
authClient.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const status = error.response && error.response.status;

    if (
      [401, 419].includes(status) &&
      store.getters['auth/authUser'] &&
      !store.getters['auth/guest']
    ) {
      store.dispatch('auth/logout');
    }

    if (![401, 419, 426].includes(status)) {
      store.commit('SET_ERROR', error);
    }

    if (status === 426) {
      console.log('upgrade required');
    }
    //store.commit('SET_ERROR', getError(error))
    //console.log(error);
    return Promise.reject(error);
  }
);

export default {
  async login(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('login', payload);
  },
  async logout() {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('/logout');
  },
  async forgotPassword(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('/forgot-password', payload);
  },
  async getAuthUser() {
    return await authClient.get('/api/user');
  },
  getPendingGoogleEmail() {
    // The API stores this value briefly in the browser's callback session. It is
    // deliberately not taken from the OAuth redirect query or browser storage.
    return authClient.get('/auth/google/pending-email');
  },
  async twoFactorChallenge(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('/two-factor-challenge', payload);
  },
  async resetPassword(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('/reset-password', payload);
  },
  updatePassword(payload) {
    return authClient.put('/user/password', payload);
  },
  async registerUser(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('/register', payload);
  },
  async checkEmailAvailability(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    const xsrfCookie = document.cookie
      .split('; ')
      .find((cookie) => cookie.startsWith('XSRF-TOKEN='));
    const xsrfToken = xsrfCookie ? decodeURIComponent(xsrfCookie.substring('XSRF-TOKEN='.length)) : null;

    return authClient.post(
      '/api/registration/email-availability',
      payload,
      xsrfToken ? { headers: { 'X-XSRF-TOKEN': xsrfToken } } : {}
    );
  },
  sendVerification(payload) {
    return authClient.post('/email/verification-notification', payload);
  },
  updateUser(payload) {
    return authClient.put('/user/profile-information', payload);
  },
};
